import { render, staticRenderFns } from "./LToogleButton.vue?vue&type=template&id=1f89b3b6"
import script from "./LToogleButton.vue?vue&type=script&lang=js"
export * from "./LToogleButton.vue?vue&type=script&lang=js"
import style0 from "./LToogleButton.vue?vue&type=style&index=0&id=1f89b3b6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports